// eslint-disable-next-line no-restricted-syntax
import { gql, useQuery } from '@apollo/client';

const GREENHOUSE_OAUTH_INTEGRATION_QUERY = gql`
  query GreenhouseOAuthIntegrationForPreferredNameTokens {
    thisOrg {
      id
      integrations {
        id
        greenhouseOauth {
          subdomain
        }
      }
    }
  }
`;

/**
 * Hook to check if the organization has connected Greenhouse OAuth (Harvest V3) integration.
 * Used to determine whether to show preferred name tokens in template editors.
 */
export const useIsGreenhouseOAuthIntegrationConnected = (): boolean => {
  const { data } = useQuery(GREENHOUSE_OAUTH_INTEGRATION_QUERY);
  return Boolean(data?.thisOrg?.integrations?.greenhouseOauth);
};
